module.exports = __webpack_public_path__ + "img/step-6.a5f43c0e.jpg";